/**
 * The valid recipe types
 * @type {Object}
 */
const recipeTypes = {
    user: {
        id: 'user',
        name: UncannyAutomator._core.i18n.recipeType.userRecipeName,
        description: UncannyAutomator._core.i18n.recipeType.userRecipeDescription,
    },
    anonymous: {
        id: 'anonymous',
        name: UncannyAutomator._core.i18n.recipeType.everyoneRecipeName,
        description: UncannyAutomator._core.i18n.recipeType.everyoneRecipeDescription,
    },
};

export default recipeTypes;
